module.exports = __webpack_public_path__ + "static/tag-7bc9dad4bcaa176c66217457fdbfa9b5.png";